import { createAsyncThunk } from '@reduxjs/toolkit';
import type { GetGlobalUsersParams, GetGlobalUsersResponse } from '../../types/globalUsers';
import { globalUsersService } from './services';

export const fetchGlobalUsers = createAsyncThunk<GetGlobalUsersResponse, GetGlobalUsersParams>(
  'globalUsers/fetch',
  async (params, { rejectWithValue }) => {
    try {
      return await globalUsersService.list(params);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
